<template>
<b-container fluid class='my-2'>
  <loading-modal
    :show="loading.show"
    :text="loading.text"
    :redirect="loading.redirect"
    :button="loading.button"
    :variant="loading.variant"
    :show-spinner="loading.showSpinner"
    @hide="loading.show = false"
  />
  <section v-if="!loading.show && canRmaHc">
    <b-row justify-content-between align-h="center">
      <b-col cols=4>
        <h1 v-if="order">{{ isHc ? 'HC' : 'RMA' }} for Order: {{ order.num }}</h1>
        <h1 v-else>Orphan {{ isHc ? 'HC' : 'RMA' }}!</h1>
      </b-col>
      <b-col class='mt-1 mr-1'>
        <b-row class='justify-content-end'>
          <b-btn-group class='mx-2'>
            <b-btn variant=secondary href="/sales-order/search">To Search</b-btn>
            <b-btn v-if="order" variant=secondary :href="`/sales-order/view/${order.num}`" target="_blank">Open {{order.num}}</b-btn>
          </b-btn-group>
          <b-btn-group class='mx-2'>
            <b-btn variant=warning @click="$refs.bulkRmaModalRef.show()">RMA Entire Order</b-btn>
            <b-btn variant=purple @click="$refs.bulkHcModalRef.show()" >HC Entire Order</b-btn>
          </b-btn-group>
          <b-btn-group class='mx-2'>
            <b-btn variant="danger" @click="resetRmaHc">Reset Form</b-btn>
            <b-btn variant="success" @click="$refs.submitModalRef.show()" :disabled="submitForm.rmaHcLines.length === 0" style="width:109.583px;">
              Next ->
            </b-btn>
          </b-btn-group>
        </b-row>
      </b-col>
    </b-row>

    <b-alert v-if="submitForm.isOrphanOrder" show variant='warning'>
      You're creating {{ isHc ? 'a HC' : 'an RMA' }} that isn't attached to an existing order!
    </b-alert>

    <div v-if="submitForm.rmaHcLines.length === 0" class='btn-group btn-group-toggle mx-1 mb-2' style="width:100%">
      <b-btn variant="outline-warning" :pressed="submitForm.orderType === 'rma'" @click="submitForm.orderType = 'rma'">RMA</b-btn>
      <b-btn variant="outline-purple" :pressed="submitForm.orderType === 'hc'" @click="submitForm.orderType = 'hc'">HC</b-btn>
    </div>

    <b-card class='my-4' :header="submitForm.orderType === 'rma' ? 'RMA Items' : 'HC Items'">
      <b-table
        responsive
        align-v="center"
        small
        :items="submitForm.rmaHcLines"
        :fields="[
          'orderItem',
          submitForm.orderType === 'hc' ? 'problem' : 'reason',
          'notes',
          'toSend',
          'toReceive',
          'note',
          { key: 'actions', label: '' }
        ]"
      >
        <template slot='orderItem' slot-scope="row">
          <div v-if="row.item.orderItem">
            <data-merger :dict="row.item.orderItem.sku" fuzzy />
            (<em><data-merger :dict="row.item.orderItem.description" fuzzy :showWarning="false" /></em>)
          </div>
          <div v-else>
            EXTRA ITEM
          </div>
        </template>
        <template slot='problem' slot-scope="row">
          {{row.item.type}} (qty {{row.item.qty}})
        </template>
        <template slot='reason' slot-scope="row">
          {{row.item.type}} (qty {{row.item.qty}})
        </template>
        <template slot='toSend' slot-scope="row">
          <ul style='padding-left:20px;'>
            <li v-for="(i,iix) in row.item.toSend" :key="`toSend-${row.index}-${iix}`">
              {{i.sku}} (qty {{i.qty}} {{i.touchInventory ? ' from stock' : ''}})
            </li>
          </ul>
        </template>
        <template slot='toReceive' slot-scope="row">
          <ul style='padding-left:20px;'>
            <li v-for="(i,iix) in row.item.toReceive" :key="`toReceive-${row.index}-${iix}`">
              <span v-if="i.type === 'nothing'">
                Not Receiving Anything
              </span>
              <span v-else>
                <span v-if="i.type==='sku'">{{i.sku}}</span>
                <span v-else-if="i.type==='image' && !i.imagesLater">{ images attached }</span>
                <span v-else-if="i.type==='image'">{ images coming later }</span>
                <span v-else-if="i.type==='notSure'">{ who knows }</span>
                (qty {{i.qty}} {{i.touchInventory ? ' to stock' : ''}})
              </span>
            </li>
          </ul>
        </template>
        <template slot='actions' slot-scope="row">
          <b-btn size=sm @click="editRmaHcLine(row)" class='mx-1'>
            <i class="fas fa-edit"></i>
          </b-btn>
          <b-btn size=sm @click="submitForm.rmaHcLines.splice(row.index, 1)" variant=danger class='mx-1'>
            <i class="fas fa-trash"></i>
          </b-btn>
        </template>
      </b-table>

      <div class='my-2'>
        <b-btn v-if="submitForm.isOrphanOrder" block @click="startReturn(null)" :variant=variantColor>
          Add Item to {{ isHc ? 'HC' : 'RMA' }}
        </b-btn>
        <b-btn v-else block @click="startOrphanReturn(null)" :variant=variantColor>
          Add Orphan Item to {{ isHc ? 'HC' : 'RMA' }}
        </b-btn>
      </div>
    </b-card>

    <div v-if="!submitForm.isOrphanOrder">
      <order-items :order="order" :rma-mode="true" @start-return="startReturn" />
    </div>
  </section>
  <section v-else>
    <div style="text-align: center;">
      <h1>
        Sorry...<br/>
        <i class="far fa-dizzy fa-5x"></i>
      </h1>
      <p style="font-size: 20px;">
        This order isn't fulfilled yet, so you can't issue an RMA for it.<br/>
        If you got to this page by pressing a button, Info may be broken, and you will not be going to space today.
      </p>
    </div>
  </section>

  <b-modal ref=bulkHcModalRef scrollable hide-footer size=lg>
    <b-form @reset="$refs.bulkHcModalRef.hide()" @submit="hcWholeOrder">
      <b-form-row>
        This info will apply to every item on the order
      </b-form-row>
      <b-form-row>
        <b-col>
          <label>Problem Type</label>
        </b-col>
        <b-col>
            <b-form-select required :options="bulkProblemTypes" v-model="batchHcForm.type" />
            <b-form-input
              v-if="batchHcForm.type === 'MiscIssue'"
              required
              placeholder="More Info (*)"
              v-model="batchHcForm.details"
            />
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <label>Problem Notes</label>
        </b-col>
        <b-col>
          <b-form-input v-model="batchHcForm.note" />
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label="Send Order from Stock" label-for="batchShipCheckbox" label-cols="8">
            <b-form-checkbox id="batchShipCheckbox" v-model="batchHcForm.send" style="margin-top: .5rem;" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group v-if="batchHcForm.type !== 'Missing'" label="Receive Order into Inventory" label-for="batchReturnCheckbox" label-cols="8">
            <b-form-checkbox id="batchReturnCheckbox" v-model="batchHcForm.receive" style="margin-top: .5rem;" />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-end">
        <b-btn type=submit variant=primary class='mx-1'>
          Add Items
        </b-btn>
        <b-btn type=reset variant=danger class='mx-1'>
          Close
        </b-btn>
      </b-form-row>
    </b-form>
  </b-modal>

  <b-modal ref=bulkRmaModalRef scrollable hide-footer size=lg>
    <b-form @reset="$refs.bulkRmaModalRef.hide()" @submit="rmaWholeOrder">
      <b-form-row>
        <b-col>
          This info will apply to every item on the order
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label="RMA Reason" label-for="batchRmaReason">
                <b-form-select id="batchRmaReason" required :options='rmaTypes' v-model="batchRmaForm.type" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="batchRmaForm.type === 'misc'">
            <b-col>
              <b-form-group label="More Info (*)" label-for="batchRmaDetails">
                <b-form-input id="batchRmaDetails" required v-model="batchRmaForm.details" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-form-group label="Restock Percentage" label-for="batchRmaRestockPercent">
            <b-input-group append="%">
              <b-form-input
                id="batchRmaRestockPercent"
                required
                type="number"
                v-model="batchRmaForm.restockPercent"
                min=0 max=100
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <label>Problem Notes</label>
        </b-col>
        <b-col>
          <b-form-input v-model="batchRmaForm.note" />
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-end mt-2">
        <b-btn type=submit variant=primary class='mx-1'>
          Add Items
        </b-btn>
        <b-btn type=reset variant=danger class='mx-1'>
          Close
        </b-btn>
      </b-form-row>
    </b-form>
  </b-modal>

  <b-modal
    ref=itemModalRef
    :title="currentItem ? `${currentItem.sku.fishbowl}: ${currentItem.description.fishbowl}` : 'Orphan Item'"
    size=lg
    scrollable hide-footer no-close-on-backdrop
    @close="cancelEditLine"
  >
    <item-form
      :isHc="isHc"
      :currentItem=currentItem
      :currentLine=currentLine
      :defaultExtra=extraItem
      @submit=addRmaHcLine
    />
  </b-modal>

  <b-modal ref=submitModalRef scrollable hide-header hide-footer size=lg>
    <b-form @reset="$refs.submitModalRef.hide()" @submit="submitRmaHc">
      <address-form :address=submitForm.address />
      <b-form-row>
        <b-col>
          <label>Email<span class="red">*</span></label>
        </b-col>
        <b-col>
          <input-merger required :dict=submitForm.address.email :disabled=false />
        </b-col>
      </b-form-row>
      <b-form-row class='my-2'>
        <b-col>
          <label>Shipping Method<span class="red">*</span></label>
        </b-col>
        <b-col cols=9>
          <input-merger required :dict="submitForm.address.carrier" select :selectOptions="shipOptions" :disabled=false @input=handleCarrierChange />
        </b-col>
      </b-form-row>
      <b-form-row v-if="submitForm.isCombine" class='my-2'>
        <b-col cols=3 />
        <b-col cols=3>
          <label>Combine With Order<span class="red">*</span></label>
        </b-col>
        <b-col>
          <b-form-input required v-model="submitForm.combineWithOrder" />
        </b-col>
      </b-form-row>
      <b-form-row class='my-2'>
        <b-col>
          <label>Order Notes</label>
        </b-col>
        <b-col cols=9>
          <b-form-textarea v-model="submitForm.notes" rows=3 max-rows=6 />
        </b-col>
      </b-form-row>
      <b-form-row class='my-2'>
        <b-col>
          <label>Send the Customer a Return Label?</label>
        </b-col>
        <b-col cols=7>
          <b-form-checkbox v-model="submitForm.sendReturnLabel" />
        </b-col>
      </b-form-row>
      <b-row align-h="end" class='my-2'>
        <b-button variant="secondary" type="reset" class="mr-2">
          Cancel
        </b-button>
        <b-button variant="primary" type="submit" class="mr-3">
          Submit
        </b-button>
      </b-row>
    </b-form>
  </b-modal>
</b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios'

import utility from '../../helpers/utility'
import bridgeService from '../../services/bridge'
import rmahcService from '../../services/rmahc'
import mergeService from '../../services/orderMerge'
import champService from '../../services/champ'

import LoadingModal from '../utility/LoadingModal.vue'
import OrderItems from '../sales-order/view-order-2/OrderItems.vue'
import DataMerger from '../utility/DataMerger.vue';
import ItemForm from './ItemForm.vue'
import InputMerger from '../utility/InputMerger.vue'
import AddressForm from '../sales-order/edit-order-2/AddressForm.vue'

export default {
  data() {
    return {
      order: undefined,
      loading: {
        show: false,
        text: 'Loading...',
        redirect: '#',
        button: null,
        variant: 'light',
        showSpinner: true
      },
      canRmaHc: undefined,
      currentItem: undefined,
      currentLine: undefined,
      extraItem: false,
      variantColor: 'purple',

      batchHcForm: {
        note: null,
        type: null,
        receive: false,
        send: false,
      },
      batchRmaForm: {
        type: null,
        note: null,
        details: null,
        restockPercent: 10,
      },

      submitForm: {
        orderId: this.$route.params.id,
        orderType: 'hc',
        address: {
          firstName: {},
          lastName: {},
          company: {},
          street1: {},
          street2: {},
          city: {},
          regionCode: {},
          countryCode: { 'fishbowl': 'US' },
          zip: {},
          phoneNumber: {},
          carrier: {},
          email: {},
        },
        isCombine: false,
        isOrphanOrder: false,
        combineWithOrder: null,
        sendReturnLabel: false,
        notes: null,
        rmaHcLines: [],
      },
    };
  },
  components: {
    LoadingModal,
    OrderItems,
    InputMerger,
    ItemForm,
    DataMerger,
    AddressForm,
  },
  mounted() {
    this.getLoggedInUser()
    this.getFishbowlRmahcShipOptions();
    if (this.$route.params.id === 'ORPHAN') {
      this.submitForm.isOrphanOrder = true;
      this.canRmaHc = true;
    }
    else {
      this.loading.show = true;
      axios.all([
        bridgeService.getSalesOrder(this.$route.params.id),
        champService.getPercentilePrices(this.$route.params.id)
      ]).then(axios.spread((orderResponse, pricesResponse) => {
        orderResponse.data.merged.items.filter(item => !!item.soItemId).forEach(item => {
          let itemMatch = pricesResponse.data.filter(x => x.parentSoItemId == item.soItemId.fishbowl)
          if (itemMatch.length > 0 && Array.isArray(item.kitItems)) {
            item.kitItems.forEach(kitItem => {
              let kitItemMatch = itemMatch.filter(x => x.childSoItemId == kitItem.soItemId.fishbowl)
              if (kitItemMatch.length == 1) {
                kitItem.percentileUnitPrice = Number(kitItemMatch[0].kitItemUnitPrice) / 100
              } else {
                console.error(`Found ${kitItemMatch.length} matches for ${kitItem.sku}(${kitItem.soItemId}) inside ${item.sku}(${item.soItemId})`)
              }
            })
          }
        })

        this.order = orderResponse.data.merged;
        if (this.order.shippingAddress) {
          this.submitForm.address = this.order.shippingAddress
        }
        if (this.order.shippingAddress.phoneNumber) {
          this.order.shippingAddress.phoneNumber.edited = utility.formatPhoneNumber(mergeService.mergeField(this.order.shippingAddress.phoneNumber))
        }
        if (this.order.email) {
          this.submitForm.address.email = this.order.email
        }
        if (this.order.shippingAddress.carrier) {
          this.submitForm.address.carrier = this.order.shippingAddress.carrier
        }

        this.canRmaHc = (
          orderResponse.data.fishbowl &&
          orderResponse.data.fishbowl.shippings &&
          orderResponse.data.fishbowl.shippings.some(x => x.status.id === 20 || x.status.id === 30)
        )
        this.loading.show = false;
      })).catch((error) => {
        console.error(error);
        this.loading.show = false;
        this.canRmaHc = false;
      })
    }
  },
  watch: {
    isHc() {
      this.variantColor = this.isHc ? 'purple' : 'warning';
    }
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
      fishbowlRmahcShipOptions: 'fishbowlRmahcShipOptions',
    }),
    isHc() { return this.submitForm.orderType === 'hc' },
    problemTypes() { return rmahcService.problemTypes; },
    bulkProblemTypes() { return this.problemTypes.filter(x => x.value != 'WrongPart') },
    rmaTypes() { return rmahcService.rmaTypes; },
    receiveTypes() { return rmahcService.receiveTypes; },
    shipOptions() {
      let selectedCarrier = mergeService.mergeField(this.submitForm.address.carrier)
      if (!this.fishbowlRmahcShipOptions.includes(selectedCarrier)) {
        let options = this.fishbowlRmahcShipOptions.slice();
        options.unshift(selectedCarrier)
        return options;
      } else {
        return this.fishbowlRmahcShipOptions;
      }
    },
  },
  methods: {
    ...mapActions({
      getLoggedInUser: 'getLoggedInUser',
      getFishbowlRmahcShipOptions: 'getFishbowlRmahcShipOptions',
    }),

    resetLoadingModal() {
      this.loading = {
        show: false,
        text: 'Loading...',
        redirect: '#',
        button: null,
        variant: 'light',
        showSpinner: true
      }
    },
    resetRmaHc() {
      window.location.reload()
    },

    hcWholeOrder(event) {
      if (event) { event.preventDefault() }
      if (this.batchHcForm.type === 'Missing') this.batchHcForm.receive = false

      this.processWholeOrder(true, this.batchHcForm.type, this.batchHcForm.note, this.batchHcForm.details, 0)
      this.$refs.bulkHcModalRef.hide()
    },
    rmaWholeOrder(event) {
      if (event) { event.preventDefault() }

      this.processWholeOrder(false, this.batchRmaForm.type, this.batchRmaForm.note, this.batchRmaForm.details, Number(this.batchRmaForm.restockPercent))
      this.$refs.bulkRmaModalRef.hide()
    },
    processWholeOrder(hc, type, note, details, restockPercent) {
      this.submitForm.orderType = hc ? 'hc' : 'rma'
      this.submitForm.rmaHcLines.splice(0)
      this.order.items.forEach(item => {
        let form = rmahcService.blankLine(item, mergeService.mergeField(item.qty))
        form.type = type
        form.userNotes = note
        form.details = details
        form.restockPercent = restockPercent

        let items = rmahcService.getWholeLineItem(item);
        if (hc) {
          if (this.batchHcForm.send) items.forEach(i => form.toSend.push(i))
          if (this.batchHcForm.receive) items.forEach(i => form.toReceive.push(i))
        } else {
          items.forEach(i => form.toReceive.push(i))
        }

        form.notes = rmahcService.getItemNote(note, form.toSend, this.loggedInUser.names)
        this.submitForm.rmaHcLines.push(form)
      })
      this.updateRefundPrices()
    },

    startReturn(item) {
      this.extraItem = false
      this.currentItem = item
      this.currentLine = null
      this.$refs.itemModalRef.show()
    },
    startOrphanReturn() {
      this.extraItem = true
      this.currentItem = null
      this.currentLine = null
      this.$refs.itemModalRef.show()
    },
    editRmaHcLine(row) {
      this.extraItem = false
      this.currentItem = row.item.orderItem
      this.currentLine = JSON.parse(JSON.stringify(row.item))
      this.currentLine.editIndex = row.index
      this.$refs.itemModalRef.show()
    },
    addRmaHcLine(form) {
      if (form.editIndex !== null) {
        this.submitForm.rmaHcLines.splice(form.editIndex, 1, form)
      } else {
        this.submitForm.rmaHcLines.push(form)
      }
      this.extraItem = false
      this.currentItem = null
      this.currentLine = null
      this.$refs.itemModalRef.hide()
    },
    cancelEditLine() {
      this.extraItem = false
      this.currentItem = null
      this.currentLine = null
    },

    validateRmaHc() {
      //TODO: ?
    },
    submitRmaHc(event) {
      event.preventDefault()
      this.resetLoadingModal();

      if (this.submitForm.isCombine) {
        this.submitForm.notes = this.joinWithPipe([
          this.submitForm.notes,
          `Combine with order: ${this.submitForm.combineWithOrder}`
        ])
      }

      let payload = {}
      try {
        payload = {
          orderNum: this.submitForm.orderId,
          isHc: this.isHc,
          isOrphanOrder: this.submitForm.isOrphanOrder,
          note: this.submitForm.notes,
          address: Object.fromEntries(Object.keys(this.submitForm.address).filter(key => !!this.submitForm.address[key] && !!this.submitForm.address[key]['edited']).map(key => [ key, this.submitForm.address[key]['edited'] ])),
          lines: this.submitForm.rmaHcLines.map(line => ({
            num: `${line.type}${this.submitForm.sendReturnLabel ? '_Return' : ''}`,
            qty: line.qty,
            soItemId: line.orderItem ? line.orderItem.soItemId.fishbowl : null,
            note: this.joinWithPipe([ line.details, line.notes ]),
            items: [
              ...line.toSend.map(item => ({ ...item, ...{ typeId: 10 } })),
              ...line.wrongPart.map(item => ({ ...item, ...{ typeId: 10, wrongPart: true } })),
              ...line.wrongPart
                .filter(item => item.touchInventory)
                .map(item => ({ ...item, ...{ typeId: 20 } })),
              ...line.toReceive.map(item => ({ ...item, ...{ typeId: 20 } }))
            ].map(item => {
              let skuNote = !!line.orderItem ? `This item is related to ${line.orderItem.sku.fishbowl} on the original order` : ""
              switch (item.type) {
                case 'sku':
                  if (!!line.orderItem && item.sku == line.orderItem.sku.fishbowl) skuNote = ""
                  let wpNote = !!item.wrongPart ? "ADJUST FOR WRONG PRODUCT SENT" : "";
                  return {
                    id: item.productId,
                    num: item.sku,
                    type: item.typeId,
                    qty: item.qty,
                    kitFlag: item.isKit,
                    taxableFlag: item.taxable,
                    note: this.joinWithPipe([wpNote, skuNote]),
                    affectStock: item.wrongPart || item.touchInventory,
                    autoReceive: !!item.wrongPart && item.typeId === 10,
                    unitPrice: parseInt(item.unitPrice * 100),
                    unitRestockPrice: parseInt((item.unitRestockPrice * 100 || 0))
                  }
                case 'notSure':
                  return {
                    id: 21916,
                    num: 'Return_NotSure',
                    type: 20,
                    qty: item.qty,
                    note: skuNote,
                    affectStock: true
                  }
                case 'image':
                  skuNote += item.imagesLater ? "The images are coming later" : ""
                  return {
                    id: 21917,
                    num: 'Return_Images',
                    type: 20,
                    qty: item.qty,
                    note: skuNote,
                    images: item.imagesLater ? [] : item.images,
                    affectStock: true
                  }
                default: throw new Error(`Unknown item type (${item.type})!!`)
              }
            }).filter(x => !!x)
          }))
        }
      } catch (e) {
        console.error(e)
        this.loading.text = "Encountered an error! Details were logged to the console. Please fetch an IT friend to help troubleshoot the issue."
        this.loading.show = true
        this.loading.variant = 'danger'
        this.loading.showSpinner = false
        return
      }
      console.log(payload)
      //return

      this.loading.text = 'Submitting RMAHC to CHAMP...',
      this.loading.show = true
      champService.submitRmaHc(payload).then((response) => {
        this.loading.text = `Waiting for fishbowl ${response.data}...`,
        this.loading.redirect = '#',
        this.loading.button = null
        utility.waitResponse(response.data, ((success) => {
          this.loading.variant = 'success'
          this.loading.text = 'Success!'
          this.loading.redirect = `/sales-order/view/${success.Response}`
          this.loading.button = 'To RMA/HC'
          this.loading.showSpinner = false
        }), ((failure) => {
          this.loading.text = failure.Response
          this.loading.button = 'Close'
          this.loading.variant = 'danger'
        this.loading.showSpinner = false
        }), (() => {
          this.loading.text = 'Request Timed Out. Wait a few seconds and search for the RMAHC. If it isn\'t there, contact IT.'
          this.loading.redirect = '/sales-order/search'
          this.loading.button = 'To Search'
          this.loading.buttonVariant = 'secondary'
        this.loading.showSpinner = false
        }), ((error) => {
          console.error(error)
          this.loading.text = 'There was an error while waiting for a response. DO NOT RESUBMIT!. See console for full message.'
          this.loading.button = 'Close'
          this.loading.variant = 'danger'
        this.loading.showSpinner = false
        }))
      }).catch((error) => {
        console.error(error)
        this.loading.text = 'There was an error while talking to CHAMP. DO NOT RESBMIT! See console for full message.'
        this.loading.button = 'Close'
        this.loading.variant = 'danger'
        this.loading.showSpinner = false
      })
    },

    joinWithPipe(lines) {
      return lines.filter(x => !!x && String(x).length > 0).join(' | ')
    },
    updateRefundPrices(event) {
      if (event) { event.preventDefault() }
      this.submitForm.rmaHcLines.forEach(line => {
        rmahcService.updateRefundPrices(this.isHc, line.toReceive, line.restockPercent);
      })
    },
    handleCarrierChange(i) {
      this.submitForm.isCombine = i === 'Combine With Another Order'
      if (!this.submitForm.isCombine) {
        this.submitForm.combineWithOrder = null
      }
    }
  },
}
</script>

<style scoped>
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/rma-hc/RmaHc.vue